import "./App.css";
import React, { useEffect } from "react";
import Home from "./components/maincomponents/Home";
import "aos/dist/aos.css";
import Aos from "aos";
// import ParticlesBackground from "./components/particles/ParticlesBackground";
import { Route, Routes } from "react-router-dom";
import Projects from "./components/insidecomponents/Projects";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function App() {
  useEffect(() => {
    Aos.init({ duration: 2000, startEvent: "load" });
    Aos.refresh();
  }, []);

  return (
    <div className="App">
      {/* <ParticlesBackground /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/works/:projectID" element={<Projects />} />
      </Routes>
    </div>
  );
}

export default App;
